// removed by extract-text-webpack-plugin
module.exports = {"actions-wrapper":"actions-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/MessageCenterGrid/subComponents/actions/Actions.scss
// module id = 5343
// module chunks = 1